var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"marker",class:{
        [`marker--${_vm.type}`]: true,
        'is-active': _vm.isActive,
    }},!_vm.answerDialogue && _vm.activeMode && (_vm.isActive
        ? _vm.state.canDelete ? { click: _vm.removeMarker } : null
        : { click: _vm.setCurrentAnswerInstance })),[_c('div',{staticClass:"marker__inner"},[_c('v-icon',{staticClass:"marker__icon",attrs:{"color":_vm.isActive ? 'primary' : 'grey darken-3'}},[_vm._v(" mdi-map-marker ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }